import { profileService } from "../../api/profileService/profileService";
import { IsAuthorized } from "../../utils/helpers/auth";

export const getProfileData = async () => {
    if (IsAuthorized()) {
        const profileRes = await profileService.getProfile();
        const businessProfileRes = await profileService.getBusinessProfile();

        if (
            profileRes.success
            && businessProfileRes.success
        ) {
            return {
                profileApi: profileRes.responseBody,
                businessProfileApi: businessProfileRes.responseBody
            }
        } else {
            console.log('error');
        }
    } else {
        return {
            profileApi: null,
            businessProfileApi: null
        }
    }
}